module.exports = __webpack_public_path__ + "img/09.6c9b1c1d.jpg";